// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

// import global components
import AlertModal from '../../../global/components/modals/AlertModal.js.jsx';
import Base from "../../../global/components/BaseComponent.js.jsx";

// import actions
import * as studyUserActions from '../../studyUser/studyUserActions';

// import third party libraries
import classNames from 'classnames';

// import module components
import RequiredTrainingStatus from './RequiredTrainingStatus.js.jsx';

class RequiredTrainingTable extends Base {
  constructor(props) {
    super(props);
    this.state = {
      confirmEmailReminder: false
      , resultModalOpen: false
      , resultMessage: ""
      , resultType: "info"
      , sendingEmail: false
    }
    this._bind(
      '_handleSendReminder'
    )
  }

  _handleSendReminder() {
    this.setState({sendingEmail: true})
    const { dispatch, match } = this.props;
    dispatch(studyUserActions.sendCompletionReminder(match.params.studyUserId)).then((suRes) => {
      if(suRes.success) {
        this.setState({
          confirmEmailReminder: false
          , resultModalOpen: true
          , resultMessage: suRes.message
          , resultType: "success"
          , sendingEmail: false
        });
      } else {
        this.setState({
          confirmEmailReminder: false
          , resultModalOpen: true
          , resultMessage: suRes.error
          , resultType: "danger"
          , sendingEmail: false
        });
      }
    });
  }

  render() {
    const {
      isArchived
      , moduleCertificates
      , studyUser
      , cmIds
      , contentModuleStore
    } = this.props;

    const btnClass = classNames(
      'yt-btn'
      , 'x-small'
      , 'warning'
      , { 'disabled': isArchived }
    )

    return (
      <div className="content-container">
        <div style={{marginBottom: '8px'}} className="yt-row space-between">
          <p><strong>Required Training</strong></p>
          { studyUser ?
              <div data-tip data-for={studyUser._id}>
                <button className={btnClass} onClick={() => this.setState({confirmEmailReminder: true})}>Send completion reminder</button>
              </div>
            :
              null
          }
        </div>
        <div className="table-wrapper">
          <table className="yt-table striped">
            <thead>
              <tr>
                <th>Content Module</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {cmIds.map((cmId, i) =>
                <RequiredTrainingStatus
                  key={cmId + i}
                  moduleCertificates={moduleCertificates.filter(c => c._contentModule === cmId)}
                  contentModule={contentModuleStore.byId[cmId]}
                />
              )}
            </tbody>
          </table>
        </div>
        <AlertModal
          alertMessage={<div><strong>CAUTION: </strong> Are you <em>sure</em> you want to send a training completion email reminder? </div>}
          alertTitle="Confirm completion email reminder"
          closeAction={() => this.setState({confirmEmailReminder: false})}
          declineText="Nevermind"
          disabled={this.state.sendingEmail}
          confirmAction={this._handleSendReminder}
          confirmText={this.state.sendingEmail ? "Sending..." : "Yes, send reminder"}
          isOpen={this.state.confirmEmailReminder}
          type="warning"
        />
        <AlertModal
          alertMessage={this.state.resultMessage}
          alertTitle="Reminder result"
          closeAction={() => this.setState({resultModalOpen: false})}
          disabled={this.state.sendingEmail}
          confirmAction={() => this.setState({resultModalOpen: false})}
          confirmText="Got it"
          isOpen={this.state.resultModalOpen}
          type={this.state.resultType}
        />
      </div>
    )
  }
}

RequiredTrainingTable.propTypes = {
  dispatch: PropTypes.func.isRequired
  , moduleCertificates: PropTypes.array
  , cmIds: PropTypes.array
}

RequiredTrainingTable.defaultProps = {
  moduleCertificates: []
  , cmIds: []
}

const mapStoreToProps = (store) => {
  return {
    contentModuleStore: store.contentModule
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(RequiredTrainingTable)
);



// WEBPACK FOOTER //
// modules/contentModule/components/RequiredTrainingTable.js.jsx